<template>
  <el-container class="index-con">
    <el-header :class="headerclass">
      <navcon></navcon>
    </el-header>
    <el-container class="main-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-main :class="mainclass">
        <router-view></router-view>
        <slot/>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  // 导入组件
  import navcon from '../components/topheader'
  import leftnav from '../components/leftnav'

  export default {
    name: 'index',
    data() {
      return {
        showclass: 'asideshow',
        showtype: false,
        headerclass: 'headershow',
        mainclass: 'mainshow'
      }
    },
    // 注册组件
    components: {
      navcon,
      leftnav
    },
    methods: {},
    created() {
      // 监听
      this.$root.Bus.$on('toggle', value => {
        if (value) {
          this.showclass = 'asideshow'
          this.headerclass = 'headershow'
          this.mainclass = 'mainshow'
        } else {
          setTimeout(() => {
            this.showclass = 'aside'
            this.headerclass = 'headerhide'
            this.mainclass = 'mainhide'
          }, 300)
        }
      })
    },
    beforeUpdate() {
    },
    // 挂载前状态(里面是操作)
    beforeMount() {
    }
  }
</script>
<style lang="less" scoped>
  .index-con {
    height: 100%;
    width: 100%;
    box-sizing: border-box;
  }

  .aside {
    width: 64px !important;
    /*height: 100%;*/
    background-color: #334157;
    margin: 0px;
  }

  .asideshow {
    width: 210px !important;
    /*height: 100%;*/
    background-color: #334157;
    margin: 0px;
  }

  .index-header,
  .index-main {
    padding: 0px;
    border-left: 0px solid #333;
  }

  .headershow {
    margin-bottom: 0;
    position: fixed;
    /*left: 240px;*/
    left: 0px;
    right: 0;
    padding: 0;
  }

  .headerhide {
    margin-bottom: 0;
    position: fixed;
    left: 64px;
    right: 0;
    padding: 0;
  }

  .asideshow,
  .aside {
    padding: 0;
    position: fixed;
    /*top: 0px;*/
    top: 60px;
    bottom: 0;
    overflow: auto;
  }

  .asideshow::-webkit-scrollbar,
  .aside::-webkit-scrollbar {
    display: none;
  }

  ;
  .mainshow {
    position: absolute;
    /*top: 40px;*/
    top: 60px;
    left: 210px;
    right: 0;
    bottom: 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .mainhide {
    position: absolute;
    top: 40px;
    left: 64px;
    right: 0;
    bottom: 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/layout/index.vue